import React, { useState } from "react";
import {
  Form,
  Input,
  DatePicker,
  InputNumber,
  Select,
  Row,
  Col,
  Tooltip,
  Checkbox,
} from "antd";
import { QuestionCircleOutlined } from "@ant-design/icons";
import useCommonsService from "../../../../services/useCommonsService";
import dayjs from "dayjs";

const { RangePicker } = DatePicker;
const { TextArea } = Input;

export const AdvertFormFirstPage = ({
  form,
  durationType,
  setDurationType,
  jobType,
  setJobType,
  isRangedWage,
  setIsRangedWage,
  startDate,
  setStartDate,
}) => {
  const disabledDate = (current) => {
    if (!startDate) {
      return false;
    }
    // Disable dates that are more than 30 days after the start date
    const maxDate = dayjs(startDate).add(30, "day");
    return current && (current.isAfter(maxDate) || current.isBefore(startDate));
  };

  const handleCalendarChange = (dates) => {
    setStartDate(dates ? dates[0] : null);
  };

  const {
    useGetAllSectors,
    useGetAllJobTypes,
    useGetDurationTypes,
    useGetWageTypes,
    useGetWagePeriods,
  } = useCommonsService();
  const { data: sectors } = useGetAllSectors();
  const { data: jobTypes } = useGetAllJobTypes();
  const { data: durationTypes } = useGetDurationTypes();
  const { data: wageTypes } = useGetWageTypes();
  const { data: wagePeriods } = useGetWagePeriods();

  const handleDurationTypeChange = (value) => {
    setDurationType(value);
  };
  const handleJobTypeChange = (value) => {
    form.setFieldValue("jobInterval", null);
    setJobType(value);
  };

  return (
    <>
      <Row gutter={16}>
        <Col xs={24} sm={12}>
          <Form.Item
            name="title"
            label="İlan Başlığı"
            rules={[
              { required: true, message: "Lütfen Zorunlu Alanları Doldurun" },
            ]}>
            <Input
              style={{ height: 35 }}
              // placeholder="İlan Başlığı"
            />
          </Form.Item>
        </Col>
        <Col xs={24} sm={12}>
          <Form.Item
            name="sectorId"
            label="Sektör"
            rules={[
              { required: true, message: "Lütfen Zorunlu Alanları Doldurun" },
            ]}>
            <Select
              options={sectors}
              style={{ height: 35 }}
              // placeholder="Sektör"
            ></Select>
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={16}>
        <Col sm={24} md={12}>
          <Form.Item
            name="personnelCount"
            label="Alınacak Personel Sayısı"
            rules={[
              {
                required: true,
                message: "Lütfen zorunlu alanları doldurunuz!",
              },
            ]}>
            <InputNumber
              min={1}
              style={{ width: "100%", height: 35 }}
              // placeholder="Personel Sayısı"
            />
          </Form.Item>
        </Col>
        <Col sm={24} md={12}>
          <Form.Item
            rules={[
              {
                required: true,
                message: "Lütfen Zorunlu Alanları Doldurun",
              },
            ]}
            name="advertStartEndDate"
            label="İlanın Aktif Olacağı Aralık (Max 30 Gün)">
            <RangePicker
              allowClear
              style={{ width: "100%" }}
              disabledDate={disabledDate}
              onCalendarChange={handleCalendarChange}
            />
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={16}>
        <Col xs={24} sm={12}>
          <Form.Item
            name="keywords"
            label="İlan ile ilgili yetenekler (Lütfen tek tek girip Enter tuşuna basınız)"
            style={{ fontSize: "18px" }}>
            <Select mode="tags" allowClear></Select>
          </Form.Item>
        </Col>
        <Col xs={24} sm={12}>
          <Form.Item
            rules={[
              {
                required: true,
                message: "Lütfen Zorunlu Alanları Doldurun",
              },
            ]}
            name="jobType"
            label="İş Tipi"
            style={{ fontSize: "18px" }}>
            <Select options={jobTypes} onChange={handleJobTypeChange} />
          </Form.Item>
        </Col>
      </Row>

      <>
        <Row gutter={16}>
          <Col xs={24} sm={12}>
            <Row gutter={8}>
              <Col xs={24} sm={12}>
                <Form.Item
                  rules={[
                    {
                      required: true,
                      message: "Lütfen Zorunlu Alanları Doldurun",
                    },
                  ]}
                  name="durationType"
                  label="Dönem Tipi"
                  style={{ fontSize: "18px" }}>
                  <Select
                    options={durationTypes}
                    onChange={handleDurationTypeChange}
                  />
                </Form.Item>
              </Col>
              <Col xs={24} sm={12}>
                <Form.Item
                  name="jobDuration"
                  label="Süre"
                  rules={[
                    {
                      required: true,
                      message: "Lütfen Zorunlu Alanları Doldurun",
                    },
                  ]}>
                  <Input />
                </Form.Item>
              </Col>
            </Row>
          </Col>
          <Col xs={24} sm={12}>
            {jobType !== "LONG_TERM" ? (
              <Form.Item
                name="jobInterval"
                label={
                  durationType === "hourly" ? "İş Tarihi" : "İş Tarihi Aralığı"
                }
                rules={[
                  {
                    required: jobType !== "ONCE",
                    message: "Lütfen Zorunlu Alanları Doldurun",
                  },
                ]}>
                <RangePicker
                  style={{ width: "100%" }}
                  placeholder={["İşe Giriş Tarihi", "İşten Çıkış Tarihi"]}
                />
              </Form.Item>
            ) : null}
          </Col>
        </Row>
      </>

      <Row gutter={16}>
        <Col xs={24}>
          <Form.Item
            name="jobDescription"
            label="İşin Tanımı"
            rules={[
              {
                required: true,
                message: "Lütfen Zorunlu Alanları Doldurun",
              },
            ]}>
            <TextArea rows={4} placeholder="Minimum 150 karakter" />
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={16}>
        <Col xs={24}>
          <Form.Item
            name="requiredQualification"
            label="Aranan Nitelikler"
            rules={[
              {
                required: true,
                message: "Lütfen Zorunlu Alanları Doldurun",
              },
              {
                min: 100,
                message: "Lütfen Yeterli Uzunlukta Bir Açıklama Giriniz!",
              },
            ]}>
            <TextArea rows={4} placeholder="Minimum 100 karakter" />
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={16}>
        <Col style={{ marginTop: 15 }} xs={24} md={5}>
          <Form.Item
            name="wageType"
            label={
              <span>
                Maaş Tipi&nbsp;
                <Tooltip title="Maaş bilgisi ilanda gözükmeyecektir">
                  <QuestionCircleOutlined
                    style={{ color: "rgba(0, 0, 0, 0.45)" }}
                  />
                </Tooltip>
              </span>
            }
            rules={[
              {
                required: true,
                message: "Lütfen Zorunlu Alanları Doldurun",
              },
            ]}>
            <Select options={wageTypes} placeholder="Maaş Tipi" />
          </Form.Item>
        </Col>
        <Col style={{ marginTop: 15 }} xs={24} md={5}>
          <Form.Item
            name="wagePeriod"
            label="Maaş Periyodu"
            rules={[
              {
                required: true,
                message: "Lütfen Zorunlu Alanları Doldurun",
              },
            ]}>
            <Select options={wagePeriods} placeholder="Maaş Periyodu" />
          </Form.Item>
        </Col>
        <Col xs={24} md={14}>
          <Row>
            <Col span={8}>
              <Form.Item label="Maaşı aralık olarak belirtmek ister misiniz?">
                <Checkbox
                  checked={isRangedWage}
                  onChange={(e) =>
                    setIsRangedWage(e.target.checked)
                  }></Checkbox>
              </Form.Item>
            </Col>
            <Col style={{ marginTop: 15 }} span={16}>
              {!isRangedWage ? (
                <Form.Item
                  name="wage"
                  label="Maaş Miktarı"
                  rules={[
                    {
                      required: !isRangedWage,
                      message: "Lütfen Zorunlu Alanları Doldurun",
                    },
                  ]}>
                  <InputNumber
                    style={{ width: "100%", height: 35 }}
                    placeholder="Maaş"
                  />
                </Form.Item>
              ) : (
                <Row gutter={8} align="middle">
                  <Col span={10}>
                    <Form.Item
                      name="minWage"
                      label="Min. Maaş"
                      rules={[
                        {
                          required: isRangedWage,
                          message: "Lütfen zorunlu alanları doldurunuz",
                        },
                      ]}>
                      <InputNumber
                        style={{ width: "100%", height: 35 }}
                        placeholder="Min"
                      />
                    </Form.Item>
                  </Col>

                  <Col span={4}>
                    <Form.Item label=" ">
                      <Input
                        style={{
                          textAlign: "center",
                          height: 35,
                          color: "black",
                          fontSize: 15,
                        }}
                        value="~"
                        disabled
                      />
                    </Form.Item>
                  </Col>

                  <Col span={10}>
                    <Form.Item
                      name="maxWage"
                      label="Max. Maaş"
                      rules={[
                        ({ getFieldValue }) => ({
                          validator(_, value) {
                            const minWage = getFieldValue("minWage");
                            if (!value || value >= minWage) {
                              return Promise.resolve();
                            }
                            return Promise.reject(
                              new Error("Lütfen Geçerli Değerler Giriniz")
                            );
                          },
                        }),
                        {
                          required: isRangedWage,
                          message: "Lütfen zorunlu alanları doldurunuz",
                        },
                      ]}>
                      <InputNumber
                        style={{ width: "100%", height: 35 }}
                        placeholder="Maksimum"
                      />
                    </Form.Item>
                  </Col>
                </Row>
              )}
            </Col>
          </Row>
        </Col>
      </Row>
    </>
  );
};
